export default __webpack_public_path__ + "static/media/graignes5.8d877aac.jpg";